module.exports = __webpack_public_path__ + "static/media/chart--big.3398d4da.png";